import { NO_SPECIFIC_EMOTION } from '../../home/redux/constants';

export const JOY_CHART_COLOR = '#FDCB6E';
export const FEAR_CHART_COLOR = '#A29BFE';
export const ANGER_CHART_COLOR = '#FC7B7B';
export const SADNESS_CHART_COLOR = '#B7CBD9';

export const labelColor = {
  joy: '#8B651B',
  anger: '#7B1A1A',
  fear: '#462994',
  sadness: '#4D6677',
};
export const chartColorCode = {
  joy: JOY_CHART_COLOR,
  fear: FEAR_CHART_COLOR,
  sadness: SADNESS_CHART_COLOR,
  anger: ANGER_CHART_COLOR,
  'no specific emotion': 'gray',
  positive: '#10B467',
  negative: '#D83232',
  neutral: '#2177E0',
  'very positive': '#108950',
  'very negative': '#9C1919',
  twitter: '#5BD8FF',
  linkedin: '#007AAA',
  youtube: '#FF0000',
  instagram: '#8A3AB9',
  reddit: '#FF4301',
  facebook: '#1a78f6',
  'channel news asia': '#ee1d24',
  'straits times': '#0b2b57',
  'business times': '#0478a9',
  totalMentions: '#000000',
};
export const chartColorCodeForFeedModalPieChart = {
  joy: JOY_CHART_COLOR,
  fear: FEAR_CHART_COLOR,
  sadness: SADNESS_CHART_COLOR,
  anger: ANGER_CHART_COLOR,
  [NO_SPECIFIC_EMOTION]: '#D4D6D9',
  positive: '#26EB8E',
  negative: '#FF3838',
  neutral: '#78B5FF',
  label: '#4F4F4F'
};

export const COLOR_CHART_LEGEND_ITEMS_AND_LABELS = '#999999';
export const COLOR_CHART_NO_DATA = '#cccccc';
export const COLOR_CHART_TITLE = '#666666';
export const DEFAULT_BUBBLE_COLOUR = 'rgba(252, 90, 3, 0.7)';
export const SENTIMENTS_EMOTIONS_CHART_PLOT_SERIES_COLOUR = '#BCE0FD';



// WEBPACK FOOTER //
// ./src/features/shared-components/chart/colorCodes.js